import React from 'react'
import Modal from '../modal'

import Configurator from '../../configurator'
import {
    authedUserConnect,
    i18n,
} from '../../validator'
import {
    S_SPORTNECT,
    S_SPORTUJ_V_OSTRAVE,
} from '../../consts'
import { isWebView } from '../../admin/actions'

@i18n()
@authedUserConnect()
export default class PromoBanner extends Configurator {

    constructor(props) {
        super(props)

        const nowMoment = moment.utc().local()

        this.state = {
            hideBanner: false,
            modalHide: true,
            banner: {
                [S_SPORTUJ_V_OSTRAVE]: {
                    show: nowMoment.isBefore('2022-05-29T23:00:00'),
                    title: '',
                    description: false,
                    image: 'https://sportnect-production-images.s3.eu-west-1.amazonaws.com/beach-pro-tour-2022.jpeg',
                    link: '/udalosti/jt-banka-ostrava-beach-pro',
                    buttonText: 'Vstupenky zakoupíte ZDE',
                },
                'sportuj_v_olomouci': {
                    show: nowMoment.isBefore('2019-06-15T23:00:00'),
                    title: 'Klikni na fandit v události a vyhraj',
                    description: 'Získej důležité informace o události.',
                    image: 'https://sportnect-production-images.s3-eu-west-1.amazonaws.com/runczech-2019.jpg',
                    link: '/udalosti/mattoni-12maraton-olomouc',
                },
                [S_SPORTNECT]: {
                    show: nowMoment.isBefore('2021-11-30T23:00:00'),
                    title: '',
                    description: `
                        <p>Vážení uživatelé Sportnectu,</p>
                        <p>doufáme, že jste s naší aplikací spokojeni a abychom vám vyjádřili náš dík, že aplikaci používáte, tak jsme domluvili s naším partnerem možnost zvýhodněných nákupů sportovního a volnočasového oblečení a doplňků za velkoobchodní ceny.</p>
                        <p>Na <a href="https://www.protrenink.cz?utm_source=Sportnect&utm_medium=banner&utm_campaign=ProtreninkVanoce" target="_blank" rel="noopener">www.protrenink.cz</a> v košíku odešlete kód: SPORTNECT21 a váš nákup vám bude přepočítán. Nabídka je platná do 30.11.</p>
                        <p>Díky, že používáte naší aplikaci Sportnect!</p>
                    `,
                    image: 'https://sportnect-production-images.s3.eu-west-1.amazonaws.com/protrening-2021.jpg',
                    link: 'https://www.protrenink.cz?utm_source=Sportnect&utm_medium=banner&utm_campaign=ProtreninkVanoce',
                    forceLink: true,
                },
            },
        }
    }

    componentDidMount() {
        this.setState({
            modalHide : !!sessionStorage.getItem('landingModalHide'),
        })
    }

    /**
     * Create session item and hide modal
     */
    hideModal = () => {
        sessionStorage.setItem('landingModalHide', 'true')

        this.setState({ hideBanner: true })
    }

    /**
     * Render
     *
     * @return {*}
     */
    render() {
        const {
            hideBanner,
            modalHide,
            banner: bannerState,
        } = this.state

        const {
            t,
            authedUser,
        } = this.props

        const {
            REACT_APP_SYSTEM: system,
        } = this.config

        const banner = bannerState[system] || {}

        if (hideBanner || modalHide || !banner.show || (banner.needLogin && !authedUser) || isWebView()) {
            return null
        }

        return (
            <Modal
                description={banner.title}
                handleHideModal={this.hideModal}
                dialogClass="modal-dialog--landing"
                content={() => (
                    <div className="p-2">
                        <div className="d-flex flex-column justify-content-center text-center">
                            <img alt="" src={banner.image} />
                        </div>
                        {banner.description !== false && (
                            <div
                                className="d-flex flex-column bg-secondary text-light justify-content-center text-center p-2"
                                dangerouslySetInnerHTML={{ __html: banner.description }}
                            />
                        )}
                        <div className="d-flex justify-content-center p-2">
                            <a
                                className="btn btn-color-brand btn-lg"
                                onClick={() => this.hideModal()}
                                href={banner.link}
                                target={banner.forceLink ? '_blank' : ''}
                            >
                                {banner?.buttonText || t('show')}
                            </a>
                        </div>
                    </div>
                )}
            />
        )
    }
}
